<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<p class="title">H.M.S. Hood vs. Bismarck</p>
<p class="subtitle">The Battleship Battle</p>
<p class="author">Theodore Taylor</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
<a id="page_7"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?071f5900